import { Container, Nav, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';
import { formatIsoDate } from '@front-activerse/common-components';

smoothscroll.polyfill();

const DayPlanMealNavigation = ({ date, events, activeMeal, setId }) => {
  return (
    <div className="sub-navigation text-center">
      <Container>
        <Nav className="d-block">
          {events.map((event) => {
            if (event.__typename === 'UserDailyDietPlanEventMeal') {
              let url;
              if (event.originalMeal?.id) {
                url = `/meals/day-plan/${formatIsoDate(date)}/${event.id}/${
                  event.mealType.type
                }/${setId}/${event.originalMeal.id}`;
              } else {
                url = `/meals/day-plan/${formatIsoDate(date)}/${event.id}/${
                  event.mealType.type
                }/${setId}/-1`;
              }
              return (
                <NavItem key={event.key}>
                  <Link
                    // exact
                    to={url}
                    replace={true}
                    className={activeMeal === event.id ? 'nav-link active' : 'nav-link'}
                  >
                    {event.mealType.name}
                  </Link>
                </NavItem>
              );
            }
            return '';
          })}
        </Nav>
      </Container>
    </div>
  );
};

export default DayPlanMealNavigation;
